import { render } from "./OrganizationSettingsPage.vue?vue&type=template&id=4875f62e&ts=true"
import script from "./OrganizationSettingsPage.vue?vue&type=script&lang=ts"
export * from "./OrganizationSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__